import client from './client';

/**
 * 모비피드
 */

// 일자별 통계
export const mobfeeDaily = (param) =>
  client.get(`/api/report/mobfeed/daily`, param);

// 일자별 통계 그래프
export const mobfeedDailyGraph = (param) =>
  client.get(`/api/report/mobfeed/daily/graph`, { params: param });

// 체널별 통계
export const mobfeeChannel = (param) =>
  client.get(`/api/report/mobfeed/channel`, param);

// 언론사별 통계
export const mobfeedMedia = (param) =>
  client.get(`/api/report/mobfeed/media`, param);
